import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_PROGRAM_ORDER_CANCEL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_PROGRAM_ORDER_CANCEL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PROGRAM_ORDER_CANCEL_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/program-orders/${id}/cancel`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
